<template>
  <div class="produk">
    <!-- <SearchView />    -->
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
        <div class="row text-white" style="padding: 15px 150px;">
        <div class="col-12 col-md-6 text-left" style="font-family: 'Manrope'; font-size: 16px; font-weight: 700;">
          Login
        </div>
        <div class="col-12 col-md-6" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Login" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.lt.sm">
        <div class="row text-white" style="padding: 10px 20px;">
        <div class="col-6 text-left" style="font-family: 'Manrope'; font-size: 10px; font-weight: 700;">
          Login
        </div>
        <div class="col-6" style="font-family: 'Poppins'; font-size: 7.5px; font-weight: 500; padding-top: 2.5px;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Login" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="bg-image" style="padding: 100px 500px; text-align: center;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
        <q-card class="my-card" flat bordered>
        <q-card-section class="q-pa-lg q-mb-sm">
            <q-img
            style="width: 200px;"
            src="img/marina.png"
          />
          <form @submit.prevent="btn_login()">
          <div class="q-mt-lg q-ml-md q-mr-md text-left">
            <q-input v-model="user.username" outlined placeholder="Username" color="purple-12" dense />
          </div>
          <div class="q-mt-lg q-ml-md q-mr-md text-left">
            <q-input v-model="user.password" outlined placeholder="Password" type="password" color="purple-12" dense />
          </div>
          <!-- <div class="row q-mt-md q-ml-md q-mr-md">
            <div class="col-5 text-left">
                <q-checkbox keep-color size="xs" v-model="ingat" label="Ingat Saya" color="purple-12" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 12px; color: #777777;" />
            </div>
            <div class="col-7 text-right">
                <q-btn no-caps to="/lupa" flat style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 12px; padding-top: 10px; color: #777777;" class="btn--no-hover" label="Lupa Password ?" />
            </div>
          </div> -->
          <q-separator class="q-mt-xl q-mb-lg q-ml-md q-mr-md" />
          <div class="row q-mt-sm q-ml-lg q-mr-lg q-mb-sm">
            <div class="col-5 text-left">
                <q-btn no-caps type="submit" color="purple-12" label="Login" style="font-family: 'Manrope'; font-size: 14px; font-weight: bold;" />
            </div>
            <div class="col-7 text-right">
                <q-btn no-caps to="/register" flat style="padding-top: 10px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 12px; color: #C039FF;" class="btn--no-hover" label="Register" />
            </div>
          </div>
        </form>
        </q-card-section>

    </q-card>
    </div>
    <div style="padding: 17.5% 25px; text-align: center;" v-if="$q.screen.lt.sm">
        <q-card class="my-card" flat bordered>
        <q-card-section class="q-pa-lg q-mb-sm">
            <q-img
            style="width: 125px;"
            src="img/marina.png"
          />
          <form @submit.prevent="login()">
          <div class="q-mt-md q-ml-sm q-mr-sm text-left">
            <q-input v-model="user.username" outlined placeholder="Username" color="purple-12" dense style="font-size: 10px;" />
          </div>
          <div class="q-mt-sm q-ml-sm q-mr-sm text-left">
            <q-input v-model="user.password" outlined placeholder="Password" type="password" color="purple-12" dense style="font-size: 10px;" />
          </div>
          <q-separator class="q-mt-lg q-mb-md q-ml-sm q-mr-sm" />
          <div class="row q-mt-xs q-ml-md q-mr-md q-mb-xs">
            <div class="col-5 text-left">
                <q-btn no-caps type="submit" color="purple-12" label="Login" style="font-family: 'Manrope'; font-size: 12.5px; font-weight: bold;" />
            </div>
            <div class="col-7 text-right">
                <q-btn no-caps to="/register" flat style="padding-top: 10px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; color: #C039FF;" class="btn--no-hover" label="Register" />
            </div>
          </div>
        </form>
        </q-card-section>

      

      <!-- <q-card-section>
        
      </q-card-section> -->
    </q-card>
    </div>
  </div>
</template>

<script>

import Joi from "joi";
  const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required()
  });

export default {
  name: 'LoginView',
  // components: {
  //   SearchView
  // },
  data () {
    return {
      pesanError: '',
      user : {
        username : "",
        password : ""
      },
    }
  },

  methods: {
    async login() {
      let promise = new Promise((resolve) => {
        resolve(
          this.btn_login()
        )
      });
      
      await promise; // tunggu sampai promise selesai (*)

      setTimeout(() => {
        this.$store.commit("hideLoading")
        this.$router.push('/');
      }, 750);
    },
    btn_login : function(){
        this.pesanError = '';
        console.log(this.user);
        if(this.validasiUser()){
          this.$store.commit("showLoading");
          const body = {
            username : this.user.username,
            password : this.user.password
          }
          fetch(this.$store.state.url.URL_AUTHENTIKASI+"login", {
            method : 'POST',
            headers : {
              'content-type' : 'application/json',
            },
            body : JSON.stringify(body),
          }).then((response) => {

            console.log(response);

                if (response.ok) {
                    return response.json();
                    // this.$store.commit("showLoading");
                }

                return response.json().then(error => {
                    throw new Error(error.message);
                    // this.$store.commit("showLoading");
                });
            })
            .then((result) => {
              console.log("=============================");
              console.log(result);
              // menyimpan token yang tergenerate dari server
              localStorage.token = result.token;
              localStorage.profile = JSON.stringify(result.profile);
              localStorage.unit = JSON.stringify(result.profile.profile.unit_kerja_id);
              setTimeout(() => {

                location.reload();
              }, 750);
            })
            .catch(error => {
              setTimeout(() => {
                this.$store.commit("hideLoading")
                this.pesanError = error.message;
              }, 750);
            });
        }
      },

      validasiUser: function(){

        const body = {
              username: this.user.username
        };
        const result = schema.validate(body);
        if (result.error === null || result.error == undefined) {
          return true;
        }
        if (result.error.message.includes("username")) {
          this.pesanError = "Username tidak valid";
        } else {
          this.pesanError = "Username tidak valid2";
        }
        return false;
      },
  },

  mounted() {
  }

}
</script>
